/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import ParameterMenu from '../designer/ParameterMenu';

var PARAMETRIZED_INPUT_ATTRIBUTE = 'data-jrs-parameterized-input';
var PARAMETRIZED_INPUT_SELECTOR = 'input[' + PARAMETRIZED_INPUT_ATTRIBUTE + ']';
export default {
    applyParameterExpressionAutocompletionMixin: function () {
        var self = this, hanlder = function () {
            ParameterMenu.onInput.apply(self, arguments);
        };
        this.$(PARAMETRIZED_INPUT_SELECTOR).on('input', hanlder);
        this.on('close', ParameterMenu.close);
        var oRemove = this.remove;
        this.remove = function () {
            this.$(PARAMETRIZED_INPUT_SELECTOR).off('input', hanlder);
            this.off('close', ParameterMenu.close);
            return oRemove.apply(this, arguments);
        };
    }
};